import { render } from "./ProductionChecklist.vue?vue&type=template&id=3d143404&scoped=true"
import script from "./ProductionChecklist.vue?vue&type=script&lang=js"
export * from "./ProductionChecklist.vue?vue&type=script&lang=js"

import "./ProductionChecklist.vue?vue&type=style&index=0&id=3d143404&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d143404"]])

export default __exports__